import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import MainButton from "./mainbutton";
import SecondaryButton from "./secondbutton";
import { Box } from "@mui/material";

type IncrementorBottonProps = {
  header: string;
  value: number;
  onUpdate?: (newValue: number) => void;
};

export default function IncrementorButton({
  header,
  onUpdate,
  value,
}: IncrementorBottonProps) {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      pb={2}
      wrap="nowrap"
    >
      <Grid item>
        <Typography variant="body1" align="left">
          {header}
        </Typography>
      </Grid>
      <Grid item>
        <Box display="flex" alignItems="center" gap={1}>
          {onUpdate ? (
            <SecondaryButton
              text="-"
              onClick={() => onUpdate(Math.max(value - 1, 0))}
            />
          ) : (
            <span style={{ display: "inline-block", width: 36 }} />
          )}
          <Typography variant="body1" align="center" sx={{ minWidth: 32 }}>
            {value || 0}
          </Typography>
          {onUpdate && (
            <MainButton text="+" onClick={() => onUpdate(value + 1)} />
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
